declare let require: any;
export const versionInfo = (() => {
  try {
    return require('../../git-version.json');
  } catch {
    // In dev the file might not exist:
    return { version: '0.0.0', hash: 'dev', buildNumber: 'YYYYMMDDHHMM' };
  }
})();
